// extracted by mini-css-extract-plugin
export var tosLink = "_48-0";